import React from 'react';
import { Session } from '../../utils/sessionStorage';
import { cx } from '../../styles';

interface SessionListProps {
  sessions: Session[];
  currentSessionId: string | null;
  onSessionSelect: (sessionId: string) => void;
  onDeleteSession: (sessionId: string) => void;
}

const SessionList: React.FC<SessionListProps> = ({
  sessions,
  currentSessionId,
  onSessionSelect,
  onDeleteSession,
}) => {
  const formatDate = (timestamp: number) => {
    const date = new Date(timestamp);
    return new Intl.DateTimeFormat('en-US', {
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    }).format(date);
  };

  return (
    <div className="flex flex-col h-full">
      {/* Sessions List */}
      <div className="overflow-y-auto flex-1 -mx-1 px-1">
        {sessions.length === 0 ? (
          <div className="text-tertiary text-center p-4 italic text-sm">
            No conversations yet
          </div>
        ) : (
          <ul className="space-y-1 list-none">
            {sessions.map((session) => (
              <li key={session.id} className="relative group">
                <div
                  className={cx(
                    'flex items-center py-2 px-3 rounded-lg cursor-pointer hover:bg-hover',
                    currentSessionId === session.id
                      ? 'bg-hover text-primary'
                      : 'text-secondary'
                  )}
                  onClick={() => onSessionSelect(session.id)}
                >
                  <div className="flex-1 min-w-0">
                    <div className="truncate font-medium">{session.title}</div>
                    <div className="text-xs text-secondary">
                      {formatDate(session.updatedAt)}
                    </div>
                  </div>

                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      onDeleteSession(session.id);
                    }}
                    className="opacity-0 group-hover:opacity-100 p-1 rounded-full hover:bg-component text-secondary transition-opacity"
                    aria-label="Delete session"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-4 w-4"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                      />
                    </svg>
                  </button>
                </div>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};

export default SessionList;
